import { styled } from '@mui/material/styles';
import { Box, Backdrop, SpeedDial, Snackbar, Alert, Chip, Stack } from "@mui/material";
import { InputLabel, FormControl, Select, MenuItem } from "@mui/material";

export const BoxContainer = styled(Box)(({ theme }) => ({
    width: '100%',
    height: '100%',
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
    rowGap: '10px',
}));

export const MinAutoRowsGridBox = styled(Box)(({ theme }) => ({
    width: '100%',
    height: '100%',
    display: 'grid',
    gridTemplateRows: 'min-content auto',
}));

export const MinAutoMinRowsGridBox = styled(Box)(({ theme }) => ({
    width: '100%',
    height: '100%',
    display: 'grid',
    gridTemplateRows: 'min-content auto min-content ',
}));

export const AutoMinRowsGridBox = styled(Box)(({ theme }) => ({
    width: '100%',
    height: '100%',
    display: 'grid',
    gridTemplateRows: 'auto min-content',
}));

export const MinAutoColumnsGridBox = styled(Box)(({ theme }) => ({
    width: '100%',
    height: '100%',
    display: 'grid',
    gridTemplateColumns: 'min-content, auto',
}));

export const AutoMinColumnsGridBox = styled(Box)(({ theme }) => ({
    width: '100%',
    height: '100%',
    display: 'grid',
    gridTemplateColumns: 'auto min-content',
}));

export const Auto1FrColumnsGridBox = styled(Box)(({ theme }) => ({
    width: '100%',
    height: '100%',
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
}));

export const IndexPlusBackdrop = styled(Backdrop)(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 1,
}));

export const LeftBottomSpeedDial = styled(SpeedDial)(({ theme }) => ({
    position: 'absolute',
    left: theme.spacing(2),
    bottom: theme.spacing(2),
}));

export const LeftBottomStack = styled(Stack)(({ theme }) => ({
    position: 'absolute',
    left: theme.spacing(2),
    bottom: theme.spacing(2),
}));

export const selectInputStyle = {
    width:'auto',
    height: '40px',

    '& .MuiOutlinedInput-root': {
        height: '40px',  
        display: 'flex',
        alignItems: 'center', 
        borderRadius: '6px',
        color: 'white',
    '& fieldset': {
        borderColor: 'rgba(255,255,255,0.5)',
    },
    '&:hover fieldset': {
        borderColor: '#5364FF',
    },
    '&.Mui-focused fieldset': {
        borderColor: '#6C7AFC',
        boxShadow: '0 0 10px rgba(83,100,255,0.4)',
    },
    // 실제 텍스트
    '& input': {
        height: '40px',
        padding: '0 12px', 
        display: 'flex',
        alignItems: 'center',
        textAlign: 'center',
        },
    },
    '& .MuiInputLabel-root': {
        fontSize: '14px',
        color: 'white',
        top: '-2px', 
    },
    '& .MuiSvgIcon-root': {
        fontSize: '18px',
        color: '#ccc',
    },
    };



export const ModalBoxBackdrop = ({ modalOpen, setModalOpen, children }) => {
    return (
        (modalOpen) &&
        <IndexPlusBackdrop open={true}>
            <Box sx={{ p: 0, width: '100%', height: '100%', position:'relative' }}>
                {children}
                <Chip sx={{ position: 'absolute', top: '10px', right: '10px' }}
                    label="닫기"
                    color="#5364FF"
                    onClick={() => { setModalOpen(false) }}
                    onDelete={() => { setModalOpen(false) }}
                />
            </Box>
        </IndexPlusBackdrop>
    )
}

export const AlertInfoSnackbar = ({ snackbarMessage, setSnackbarMessage }) => {
    return (
        (snackbarMessage !== null) &&
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            open={true} autoHideDuration={5000} onClose={() => setSnackbarMessage(null)}
        >
            <Alert onClose={() => setSnackbarMessage(null)} variant="filled" severity="info" sx={{ width: '100%' }}>
                {snackbarMessage}
            </Alert>
        </Snackbar>
    );
}
export const HourSelect = ({ label, value, onChange, inputSx }) => {
    const getLoopData = () => {
        const arr = []
        for (var i = 0; i <= 23; i++) {
            arr.push({ text: String(i + 1).padStart(2, '0'), value: i });
        }
        return arr;
    }

    return (
        <FormControl sx={{ minWidth: '100px', ...inputSx }} size='small'>
            <InputLabel id="simple-select-label">{label}</InputLabel>
            <Select
                labelId="simple-select-label"
                id="simple-select"
                value={value}
                label={label}
                sx={inputSx}
                onChange={(e, params) => onChange(params.props.value)}
            >
                {getLoopData().map(item => <MenuItem key={item.value} value={item.value}>{item.text}시</MenuItem>)}
            </Select>
        </FormControl>
    )
}